import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
	Button,
	Modal,
	Form,
	Dropdown,
	Input,
	TextArea,
	IconGroup,
} from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
//import moment, { months } from 'moment';
//import 'moment/locale/es';
import { toast } from 'react-toastify';
import { DateInput } from 'semantic-ui-calendar-react';
import { getRegions, municipalities } from '../utils/Functions';
import firebase, { firestore } from '../firebase';
import EventService from '../services/EventService';
import { fetchData } from '../store/actions/Archive';
import {
	formal_treatmentValue,
	harm_reductionValue,
	other_substanceValue,
	overDoseValue,
	symptoms_overdoseValue,
	naloxoneValue,
} from '../assests/labels.json';

let options = {
	timeZone: 'Etc/UTC',
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
};
let formatter = new Intl.DateTimeFormat("en-US", options);

function EventEditor(props) {
	const [label, setLabel] = useState('Explique');
	const user = useSelector((state) => state.auth.user);
	const auth = useSelector((state) => state.auth);
	const details = useSelector((state) => state.auth.details);

	const [selectedMunicipality, setSelectedMunicipality] = useState('');
	const [addressList, setAddressList] = useState([]);

	const dispatch = useDispatch();
	const schema = Yup.object().shape({
		gender: Yup.string().required('Requerido'),
		age: Yup.string().required('Requerido'),
		date: Yup.date().required('Requerido'),
		time: Yup.string().required('Requerido'),
		barrio_generic: Yup.string(), //.required('Requerido'),
		municipality: Yup.string().required('Requerido'),
		prescribed: Yup.string().required('Requerido'),
		naloxone: Yup.string().required('Requerido'),
		where: Yup.string().when('passed', {
			is: 'No',
			then: Yup.string().required('Requerido'),
		}),
		home: Yup.string().required('Requerido'),
		provider: Yup.string().required('Requerido'),
		contactName: Yup.string().required('Requerido'),
		contactLastName: Yup.string().required('Requerido'),
		email: Yup.string().email('Correo electrónico no valido'),
		phone: Yup.string().required('Requerido'),
		isThreshingWasUsed: Yup.string().required('Requerido'),
		opioids: Yup.string().required('Requerido'),
		other_substance: Yup.string().required('Requerido'),
		opioidesLugar: Yup.string().required('Requerido'),
		place: Yup.string().required('Requerido'),
	});

	useEffect(() => {
		if (props?.event?.municipio) {
			const fetchAddresses = async () => {

				const addresses = await EventService.getMunicipalityAdresses(
					props.event.municipio
				);
				const convertedJson = addresses.data.map((item) => ({
					key: item.barrio,
					text: item.barrio,
					value: item.barrio,
				}));

				setAddressList(convertedJson);
			};

			fetchAddresses();
		}
	}, [props.event]);

	useEffect(() => {
		if (selectedMunicipality) {
			const fetchAddresses = async () => {
				try {
					const addresses = await EventService.getMunicipalityAdresses(
						selectedMunicipality
					);
					const convertedJson = addresses.data.map((item) => ({
						key: item.barrio,
						text: item.barrio,
						value: item.barrio,
					}));

					setAddressList(convertedJson);
				} catch (error) {
					console.error('Failed to fetch addresses:', error);
				}
			};

			fetchAddresses();
		}
	}, [selectedMunicipality]);

	const entityGroupMapping = {
		"Centro de Detención Correccional - Salinas": "Centro de Detención Correccional - Salinas",
		"Centro de Detención Correccional - Oeste": "Centro de Detención Correccional - Oeste",
		"Inst. Correccional - Bayamón": "Inst. Correccional - Bayamón",
		"Inst. Correccional - Bayamón 1072": "Inst. Correccional - Bayamón",
		"Inst. Correccional - Bayamón 501": "Inst. Correccional - Bayamón",
		"Inst. Correccional - Bayamón 705": "Inst. Correccional - Bayamón",
		"Inst. Correccional - Guayama": "Inst. Correccional - Guayama",
		"Inst. Correccional - Guayama 1000": "Inst. Correccional - Guayama",
		"Inst. Correccional - Guayama 296": "Inst. Correccional - Guayama",
		"Inst. Correccional - Guayama 500": "Inst. Correccional - Guayama",
		"Inst. Correccional - Guerrero 304": "Inst. Correccional - Aguadilla",
		"Inst. Correccional - Ponce": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce 1000": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce 224": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce 500": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce 501": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce 705": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce Máxima": "Inst. Correccional - Ponce",
		"Inst. Correccional - Ponce Mínima": "Inst. Correccional - Ponce",
		"Inst. Correccional - Sabana Hoyos": "Inst. Correccional - Sabana Hoyos",
		"Inst. Correccional - Sabana Hoyos 216": "Inst. Correccional - Sabana Hoyos",
		"Inst. Correccional - Sabana Hoyos 384": "Inst. Correccional - Sabana Hoyos",
		"Inst. Correccional - Sabana Hoyos 782": "Inst. Correccional - Sabana Hoyos",
		"Inst. Correccional - Máxima Seguridad Bayamón 292": "Inst. Correccional - Bayamón",
		"Complejo Correccional de Rehabilitación para Mujeres": "Inst. Correccional - Bayamón",
		"Inst. Correccional - Centro Ingresos Ponce 676": "Inst. Correccional - Ponce"
	};

	if (props.event)
		return (
			<Formik
				initialValues={{
					gender: props.event ? props.event.genero : '',
					otherGender: props.event ? props.event.genero_otro : '',
					pregnant: props.event ? props.event.embarazada : '',
					weeks: props.event ? props.event.semanas_embarazo : '',
					age: props.event ? props.event.edad : '',
					//date: props.event ? props.event.fecha_evento : '',
					date: props.event
						? formatter.format(new Date(props.event.fecha_evento))
						: '',

					time: props.event ? props.event.hora_evento : '',
					//address: props.event ? props.event.barrio_generic : '',
					barrio_generic: props.event ? props.event.barrio_generic : '',
					place: props.event ? props.event.lugar : '',
					administration: props.event ? props.event.naloxona_dosis : '',
					administrator: props.event ? props.event.administrador_naloxona : '',
					otherAdministrator: props.event
						? props.event.administrador_naloxona_otro
						: '',
					trained: props.event ? props.event.administrador_adiestrado : '',
					prescribed: props.event ? props.event.opiodes_recetados : '',
					opioids: props.event ? props.event.opiodes : [],
					opioidsOther: props.event ? props.event.opiodes_otro : '',
					medicalEmergencyAttended: props.event
						? props.event.atendio_emergencias_medica
						: '',
					where: props.event ? props.event.traslado : '',
					otherWhere: props.event ? props.event.traslado_otro : '',
					description: props.event ? props.event.descripcion_evento : '',
					resident: props.event ? props.event.residente : '',
					home: props.event ? props.event.pernocta : '',
					otherHome: props.event ? props.event.pernocta_otro : '',
					country: props.event ? props.event.pais : '',
					state: props.event ? props.event.estado : '',
					institution: props.event ? props.event.institucion : '',
					otherInstitution: props.event ? props.event.institucion_otro : '',
					provider: props.event ? props.event.proveedor_naloxona : '',
					otherProvider: props.event ? props.event.proveedor_naloxona_otro : '',
					contactName: props.event ? props.event.nombre : details.name,
					contactLastName: props.event
						? props.event.apellido
						: details.lastName,
					phone: props.event ? props.event.telefono : details.phone,
					email: props.event ? props.event.email : details.email,
					entity: props.event ? props.event.entidad : details.entity,
					entidad_otro: props.event ? props.event.entidad_otro : '',
					typeOfEntity: props.event ? props.event.tipo_de_entidad : '',
					municipality: props.event ? props.event.municipio : '',
					zipCode: props.event ? props.event.zipCode : '',
					region: '',
					estado_duplicado: props.event ? props.event.estado_duplicado : '',

					//new
					sex: props.event ? props.event.sex : '',
					otherPlace: props.event ? props.event.otherplace : '',
					isThreshingWasUsed: props.event ? props.event.isthreshingwasused : '',
					istestresult: props.event ? props.event.istestresult : '',
					naloxone_if_no: props.event ? props.event.naloxone_if_no : '',
					dosisIntranasal: props.event ? props.event.dosis_intranasal : '',
					dosisIntramuscular: props.event
						? props.event.dosis_intramuscular
						: '',
					other_substance: props.event ? props.event.other_substance : [],
					other_substance_Especifique: props.event
						? props.event.other_substance_especifique
						: '',
					opioidesLugar: props.event ? props.event.opioides_lugar : '',
					sintomasSobredosis: props.event
						? props.event.sintomas_sobredosis
						: [],
					other_symptoms_overdose: props.event
						? props.event.other_symptoms_overdose
						: '',
					estadoPersona: props.event ? props.event.estado_persona : [],
					formal_treatment: props.event ? props.event.formal_treatment : '',
					institucionesValor: props.event ? props.event.instituciones : [],
					especifiqueInstituciones: props.event
						? props.event.especifique_instituciones
						: '',
					estrategiaDeReduccion: props.event
						? props.event.estrategia_de_reduccion
						: [],
					especifiqueEstrategia: props.event
						? props.event.especifique_estrategia
						: '',
					form_responsible: props.event ? props.event.form_responsible : '',
					father_initial: props.event ? props.event.father_initial : '',
					mother_initial: props.event ? props.event.mother_initial : '',
					father_dob: props.event ? props.event.father_dob : '',
					month_of_birth: props.event ? props.event.month_of_birth : '',
					need_naloxone: props.event ? props.event.need_naloxone : '',
					viaNaloxona: props.event ? props.event.via_naloxona : [],

					//modified
					naloxone: props.event ? props.event.naloxona : '',
					place_description: props.event ? props.event.place_description : '',
					passed: props.event ? props.event.fallecio : '',
				}}
				validationSchema={schema}
				onSubmit={(values, { setSubmitting }) => {
					if (values.estado_duplicado === 'Sin Evaluar') {
						values.estado_duplicado = null;
					}
					let entidad_group = entityGroupMapping[values.entity] || values.entity;

					const date = new Date(formatter.format(new Date(values.date)));
				    const month = (date.getMonth() + 1).toString(); // getMonth() returns 0-11, so add 1
					const year = date.getFullYear().toString();
					
					// let month = moment(values.date).format('M');
					// let year = moment(values.date, 'MM/DD/YYYY').year();

					let region = getRegions(values.municipality);

					let userEmail = user.email;
					let currentDate = new Date();

					const jsonbody = {
						...values,
						entidad_group,
						month,
						year,
						region,
						userEmail,
						currentDate,
						passed: Array.isArray(values.estadoPersona) && values.estadoPersona.includes('Murió') ? 'Sí' : 'No',
					};

					EventService.updateEvent(props.event.doc, jsonbody)
						.then((res) => {
							setSubmitting(false);
							dispatch(fetchData(auth));
							toast.success(
								'!Gracias! El evento ha sido editado correctamente.'
							);
						})
						.catch((error) => {
							toast.error(
								`!Lo sentimos! Hubo un error al editar el evento. ${error.message}`
							);
							setSubmitting(false);
							EventService.logError({ message: error.message, stack: error.stack });
						});
				}}
			>
				{({
					values,
					errors,
					handleChange,
					handleBlur,
					handleSubmit,
					isSubmitting,
					setFieldValue,
					setFieldTouched,
					touched,
				}) => {
					return (
						<Modal
							as={Form}
							open={props.open}
							onClose={props.onClose}
							centered={false}
							onSubmit={handleSubmit}
							noValidate
						>
							<Modal.Header>Evento</Modal.Header>
							<Modal.Content scrolling>
								<div className="border round mb-10">
									<div className="round-t fill-grey strong p-10 mb-20">
										Información demográfica de la persona que sufrió el evento
									</div>
									<Form.Group widths="equal">
										<Form.Field
											label="1. Sexo"
											name="sex"
											selection
											onChange={(e, { value }) => {
												setFieldValue('sex', value);
											}}
											onClose={() => {
												setFieldTouched('sex');
											}}
											value={values.sex}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Masculino',
													text: 'Masculino',
													value: 'Masculino',
												},
												{
													key: 'Femenino',
													text: 'Femenino',
													value: 'Femenino',
												},
												{
													key: 'Intersexual',
													text: 'Intersexual',
													value: 'Intersexual',
												},
											]}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="2. Género"
											name="gender"
											selection
											required
											onChange={(e, { value }) => {
												setFieldValue('gender', value);
											}}
											onClose={() => {
												setFieldTouched('gender');
											}}
											value={values.gender}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Masculino',
													text: 'Masculino',
													value: 'Masculino',
												},
												{
													key: 'Femenino',
													text: 'Femenino',
													value: 'Femenino',
												},
												{
													key: 'Transgénero (M→F)',
													text: 'Transgénero (M→F)',
													value: 'Transgénero (M→F)',
												},
												{
													key: 'Transgénero (F→M)',
													text: 'Transgénero (F→M)',
													value: 'Transgénero (F→M)',
												},
												{
													key: 'Otro',
													text: 'Otro',
													value: 'Otro',
												},
											]}
											error={errors.gender && touched.gender && errors.gender}
										/>
										<Form.Field
											label="Otro (se auto-identifica como…)"
											name="otherGender"
											onChange={handleChange}
											value={values.otherGender || ''}
											control={Input}
											disabled={values.gender !== 'Otro'}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="3. Si es persona gestante, ¿se encuentra embarazada?"
											name="pregnant"
											selection
											clearable
											onChange={(e, { value }) => {
												setFieldValue('pregnant', value);
											}}
											onClose={() => {
												setFieldTouched('pregnant');
											}}
											value={values.pregnant || ''}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sí',
													text: 'Sí',
													value: 'Sí',
												},
												{
													key: 'No',
													text: 'No',
													value: 'No',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
										/>
										<Form.Field
											className="display-grid"
											label="Especifique # semanas de embarazo"
											name="weeks"
											onChange={handleChange}
											value={values.weeks || ''}
											control={Input}
											type="number"
											disabled={values.pregnant !== 'Sí'}
										/>
										<Form.Field
											className="display-grid"
											required
											label="4. Edad aproximada"
											name="age"
											id="age"
											selection
											search
											onChange={(e, { value }) => {
												setFieldValue('age', value);
											}}
											onClose={() => {
												setFieldTouched('age');
											}}
											value={values.age}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: '15 a 24',
													text: '15 a 24',
													value: '15 a 24',
												},
												{
													key: '25 a 34',
													text: '25 a 34',
													value: '25 a 34',
												},
												{
													key: '35 a 44',
													text: '35 a 44',
													value: '35 a 44',
												},
												{
													key: '45 a 54',
													text: '45 a 54',
													value: '45 a 54',
												},
												{
													key: '55 a 64',
													text: '55 a 64',
													value: '55 a 64',
												},
												{
													key: '65+',
													text: '65+',
													value: '65+',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											error={errors.age && touched.age && errors.age}
										/>
									</Form.Group>
								</div>
								<div className="border round mb-10">
									<div className="round-t fill-grey strong p-10 mb-20">
										Evento de sobredosis
									</div>
									<Form.Group widths="equal">
										<Form.Field
											required
											label={`5. Fecha del evento (${new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })})`}
											name="date"
											initialDate={new Date()}
											//dateFormat="LL"
											dateFormat="MM/DD/YYYY"
											maxDate={new Date().toLocaleDateString('en-US')}
											onChange={(e, { value }) => {
												setFieldValue('date', value);
											}}
											onBlur={() => {
												setFieldTouched('date');
											}}
											value={formatter.format(new Date(values.date))}
											control={DateInput}
											animation="none"
											pickerStyle={{ fontSize: '.78571429rem' }}
											hideMobileKeyboard
											error={errors.date && touched.date && errors.date}
										/>
										<Form.Field
											required
											label="6. Hora (am o pm)"
											name="time"
											selection
											search
											onChange={(e, { value }) => {
												setFieldValue('time', value);
											}}
											onClose={() => {
												setFieldTouched('time');
											}}
											options={[
												{
													key: '12:00am a 5:59am',
													text: '12:00am a 5:59am',
													value: '12:00am a 5:59am',
												},
												{
													key: '6:00am a 11:59am',
													text: '6:00am a 11:59am',
													value: '6:00am a 11:59am',
												},
												{
													key: '12:00pm a 5:59pm',
													text: '12:00pm a 5:59pm',
													value: '12:00pm a 5:59pm',
												},
												{
													key: '6:00pm a 11:59pm',
													text: '6:00pm a 11:59pm',
													value: '6:00pm a 11:59pm',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											value={values.time}
											control={Dropdown}
											selectOnBlur={false}
											animation="none"
											error={errors.time && touched.time && errors.time}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											required
											label="7. Municipio"
											name="municipality"
											selection
											search
											onChange={(e, { value }) => {
												setFieldValue('municipality', value);
												setSelectedMunicipality(value);
											}}
											onClose={() => {
												setFieldTouched('municipality');
											}}
											value={values.municipality || ''}
											control={Dropdown}
											selectOnBlur={false}
											options={municipalities()}
											error={
												errors.municipality &&
												touched.municipality &&
												errors.municipality
											}
										/>
										<Form.Field
											label="8. Tipo de lugar donde ocurrió el evento"
											name="place"
											selection
											clearable
											search
											onChange={(e, { value }) => {
												setFieldValue('place', value);
											}}
											value={values.place}
											control={Dropdown}
											selectOnBlur={false}
											required
											error={errors.place && touched.place && errors.place}
											options={[
												{
													key: 'Auto',
													text: 'Auto',
													value: 'Auto',
												},
												{
													key: 'casa móvil(rodante)',
													text: 'casa móvil(rodante)',
													value: 'casa móvil(rodante)',
												},
												{
													key: 'Hogar transitorio (albergue)',
													text: 'Hogar transitorio (albergue)',
													value: 'Hogar transitorio (albergue)',
												},
												{
													key:
														'Lugar público en espacio abierto(calle, parque)',
													text:
														'Lugar público en espacio abierto(calle, parque)',
													value:
														'Lugar público en espacio abierto(calle, parque)',
												},
												{
													key:
														'Lugar público en espacio cerrado(casa rescatada, centro comercial)',
													text:
														'Lugar público en espacio cerrado(casa rescatada, centro comercial)',
													value:
														'Lugar público en espacio cerrado(casa rescatada, centro comercial)',
												},
												{
													key: 'Lugar privado(vivienda, habitación de hotel)',
													text: 'Lugar privado(vivienda, habitación de hotel)',
													value: 'Lugar privado(vivienda, habitación de hotel)',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
												{
													key: 'Otro (especifique)',
													text: 'Otro (especifique)',
													value: 'Otro (especifique)',
												},
											]}
										/>
										<Form.Field
											label="Especifique"
											name="otherPlace"
											disabled={values.place !== 'Otro (especifique)'}
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.otherPlace || ''}
											control={Input}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="Descripción del lugar"
											name="place_description"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.place_description || ''}
											control={Input}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="Barrio/Sector o Vencindario"
											name="barrio_generic"
											selection
											search
											clearable
											value={values.barrio_generic || ''}
											onChange={(e, { value }) => {
												setFieldValue('barrio_generic', value);
											}}
											onClose={() => {
												setFieldTouched('barrio_generic');
											}}
											control={Dropdown}
											selectOnBlur={false}
											options={addressList}
											error={
												errors.barrio_generic &&
												touched.barrio_generic &&
												errors.barrio_generic
											}
										/>
										<Form.Field
											label="Código postal"
											name="zipCode"
											selection
											search
											clearable
											value={values.zipCode}
											onChange={(e, { value }) => {
												setFieldValue('zipCode', value);
											}}
											onClose={() => {
												setFieldTouched('zipCode');
											}}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{ text: '00601', value: '00601', key: '00601' },
												{ text: '00602', value: '00602', key: '00602' },
												{ text: '00603', value: '00603', key: '00603' },
												{ text: '00604', value: '00604', key: '00604' },
												{ text: '00605', value: '00605', key: '00605' },
												{ text: '00606', value: '00606', key: '00606' },
												{ text: '00610', value: '00610', key: '00610' },
												{ text: '00611', value: '00611', key: '00611' },
												{ text: '00612', value: '00612', key: '00612' },
												{ text: '00613', value: '00613', key: '00613' },
												{ text: '00614', value: '00614', key: '00614' },
												{ text: '00616', value: '00616', key: '00616' },
												{ text: '00617', value: '00617', key: '00617' },
												{ text: '00622', value: '00622', key: '00622' },
												{ text: '00623', value: '00623', key: '00623' },
												{ text: '00624', value: '00624', key: '00624' },
												{ text: '00627', value: '00627', key: '00627' },
												{ text: '00631', value: '00631', key: '00631' },
												{ text: '00636', value: '00636', key: '00636' },
												{ text: '00637', value: '00637', key: '00637' },
												{ text: '00638', value: '00638', key: '00638' },
												{ text: '00641', value: '00641', key: '00641' },
												{ text: '00646', value: '00646', key: '00646' },
												{ text: '00647', value: '00647', key: '00647' },
												{ text: '00650', value: '00650', key: '00650' },
												{ text: '00652', value: '00652', key: '00652' },
												{ text: '00653', value: '00653', key: '00653' },
												{ text: '00656', value: '00656', key: '00656' },
												{ text: '00659', value: '00659', key: '00659' },
												{ text: '00660', value: '00660', key: '00660' },
												{ text: '00662', value: '00662', key: '00662' },
												{ text: '00664', value: '00664', key: '00664' },
												{ text: '00667', value: '00667', key: '00667' },
												{ text: '00669', value: '00669', key: '00669' },
												{ text: '00670', value: '00670', key: '00670' },
												{ text: '00674', value: '00674', key: '00674' },
												{ text: '00676', value: '00676', key: '00676' },
												{ text: '00677', value: '00677', key: '00677' },
												{ text: '00678', value: '00678', key: '00678' },
												{ text: '00680', value: '00680', key: '00680' },
												{ text: '00681', value: '00681', key: '00681' },
												{ text: '00682', value: '00682', key: '00682' },
												{ text: '00683', value: '00683', key: '00683' },
												{ text: '00685', value: '00685', key: '00685' },
												{ text: '00687', value: '00687', key: '00687' },
												{ text: '00688', value: '00688', key: '00688' },
												{ text: '00690', value: '00690', key: '00690' },
												{ text: '00692', value: '00692', key: '00692' },
												{ text: '00693', value: '00693', key: '00693' },
												{ text: '00694', value: '00694', key: '00694' },
												{ text: '00698', value: '00698', key: '00698' },
												{ text: '00703', value: '00703', key: '00703' },
												{ text: '00704', value: '00704', key: '00704' },
												{ text: '00705', value: '00705', key: '00705' },
												{ text: '00707', value: '00707', key: '00707' },
												{ text: '00714', value: '00714', key: '00714' },
												{ text: '00715', value: '00715', key: '00715' },
												{ text: '00716', value: '00716', key: '00716' },
												{ text: '00717', value: '00717', key: '00717' },
												{ text: '00718', value: '00718', key: '00718' },
												{ text: '00719', value: '00719', key: '00719' },
												{ text: '00720', value: '00720', key: '00720' },
												{ text: '00721', value: '00721', key: '00721' },
												{ text: '00723', value: '00723', key: '00723' },
												{ text: '00725', value: '00725', key: '00725' },
												{ text: '00726', value: '00726', key: '00726' },
												{ text: '00727', value: '00727', key: '00727' },
												{ text: '00728', value: '00728', key: '00728' },
												{ text: '00729', value: '00729', key: '00729' },
												{ text: '00730', value: '00730', key: '00730' },
												{ text: '00731', value: '00731', key: '00731' },
												{ text: '00732', value: '00732', key: '00732' },
												{ text: '00733', value: '00733', key: '00733' },
												{ text: '00734', value: '00734', key: '00734' },
												{ text: '00735', value: '00735', key: '00735' },
												{ text: '00736', value: '00736', key: '00736' },
												{ text: '00737', value: '00737', key: '00737' },
												{ text: '00738', value: '00738', key: '00738' },
												{ text: '00739', value: '00739', key: '00739' },
												{ text: '00740', value: '00740', key: '00740' },
												{ text: '00741', value: '00741', key: '00741' },
												{ text: '00742', value: '00742', key: '00742' },
												{ text: '00744', value: '00744', key: '00744' },
												{ text: '00745', value: '00745', key: '00745' },
												{ text: '00751', value: '00751', key: '00751' },
												{ text: '00754', value: '00754', key: '00754' },
												{ text: '00757', value: '00757', key: '00757' },
												{ text: '00765', value: '00765', key: '00765' },
												{ text: '00766', value: '00766', key: '00766' },
												{ text: '00767', value: '00767', key: '00767' },
												{ text: '00769', value: '00769', key: '00769' },
												{ text: '00771', value: '00771', key: '00771' },
												{ text: '00772', value: '00772', key: '00772' },
												{ text: '00773', value: '00773', key: '00773' },
												{ text: '00775', value: '00775', key: '00775' },
												{ text: '00777', value: '00777', key: '00777' },
												{ text: '00778', value: '00778', key: '00778' },
												{ text: '00780', value: '00780', key: '00780' },
												{ text: '00782', value: '00782', key: '00782' },
												{ text: '00783', value: '00783', key: '00783' },
												{ text: '00784', value: '00784', key: '00784' },
												{ text: '00785', value: '00785', key: '00785' },
												{ text: '00786', value: '00786', key: '00786' },
												{ text: '00791', value: '00791', key: '00791' },
												{ text: '00792', value: '00792', key: '00792' },
												{ text: '00794', value: '00794', key: '00794' },
												{ text: '00795', value: '00795', key: '00795' },
												{ text: '00901', value: '00901', key: '00901' },
												{ text: '00902', value: '00902', key: '00902' },
												{ text: '00906', value: '00906', key: '00906' },
												{ text: '00907', value: '00907', key: '00907' },
												{ text: '00908', value: '00908', key: '00908' },
												{ text: '00909', value: '00909', key: '00909' },
												{ text: '00910', value: '00910', key: '00910' },
												{ text: '00911', value: '00911', key: '00911' },
												{ text: '00912', value: '00912', key: '00912' },
												{ text: '00913', value: '00913', key: '00913' },
												{ text: '00914', value: '00914', key: '00914' },
												{ text: '00915', value: '00915', key: '00915' },
												{ text: '00916', value: '00916', key: '00916' },
												{ text: '00917', value: '00917', key: '00917' },
												{ text: '00918', value: '00918', key: '00918' },
												{ text: '00919', value: '00919', key: '00919' },
												{ text: '00920', value: '00920', key: '00920' },
												{ text: '00921', value: '00921', key: '00921' },
												{ text: '00923', value: '00923', key: '00923' },
												{ text: '00924', value: '00924', key: '00924' },
												{ text: '00925', value: '00925', key: '00925' },
												{ text: '00926', value: '00926', key: '00926' },
												{ text: '00927', value: '00927', key: '00927' },
												{ text: '00928', value: '00928', key: '00928' },
												{ text: '00929', value: '00929', key: '00929' },
												{ text: '00930', value: '00930', key: '00930' },
												{ text: '00931', value: '00931', key: '00931' },
												{ text: '00933', value: '00933', key: '00933' },
												{ text: '00934', value: '00934', key: '00934' },
												{ text: '00936', value: '00936', key: '00936' },
												{ text: '00940', value: '00940', key: '00940' },
												{ text: '00949', value: '00949', key: '00949' },
												{ text: '00950', value: '00950', key: '00950' },
												{ text: '00951', value: '00951', key: '00951' },
												{ text: '00952', value: '00952', key: '00952' },
												{ text: '00953', value: '00953', key: '00953' },
												{ text: '00954', value: '00954', key: '00954' },
												{ text: '00956', value: '00956', key: '00956' },
												{ text: '00957', value: '00957', key: '00957' },
												{ text: '00958', value: '00958', key: '00958' },
												{ text: '00959', value: '00959', key: '00959' },
												{ text: '00960', value: '00960', key: '00960' },
												{ text: '00961', value: '00961', key: '00961' },
												{ text: '00962', value: '00962', key: '00962' },
												{ text: '00963', value: '00963', key: '00963' },
												{ text: '00965', value: '00965', key: '00965' },
												{ text: '00966', value: '00966', key: '00966' },
												{ text: '00968', value: '00968', key: '00968' },
												{ text: '00969', value: '00969', key: '00969' },
												{ text: '00970', value: '00970', key: '00970' },
												{ text: '00971', value: '00971', key: '00971' },
												{ text: '00976', value: '00976', key: '00976' },
												{ text: '00977', value: '00977', key: '00977' },
												{ text: '00978', value: '00978', key: '00978' },
												{ text: '00979', value: '00979', key: '00979' },
												{ text: '00981', value: '00981', key: '00981' },
												{ text: '00982', value: '00982', key: '00982' },
												{ text: '00983', value: '00983', key: '00983' },
												{ text: '00984', value: '00984', key: '00984' },
												{ text: '00985', value: '00985', key: '00985' },
												{ text: '00986', value: '00986', key: '00986' },
												{ text: '00987', value: '00987', key: '00987' },
												{ text: '00988', value: '00988', key: '00988' },
											]}
										/>
									</Form.Group>

									<Form.Group widths="equal">
										<Form.Field
											label="9. Se utilizó tirilla de fentanilo"
											name="isThreshingWasUsed"
											selection
											clearable
											onChange={(e, { value }) => {
												setFieldValue('isThreshingWasUsed', value);
											}}
											onClose={() => {
												setFieldTouched('isThreshingWasUsed');
											}}
											value={values.isThreshingWasUsed}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sí',
													text: 'Sí',
													value: 'Sí',
												},
												{
													key: 'No',
													text: 'No',
													value: 'No',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											required
											error={
												errors.isThreshingWasUsed &&
												touched.isThreshingWasUsed
											}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											disabled={
												values.isThreshingWasUsed !== 'Sí' ? true : false
											}
											label="De la respuesta ser Sí, ¿cuál fue el resultado de la prueba?  "
											name="istestresult"
											selection
											clearable
											onChange={(e, { value }) => {
												if (values.isThreshingWasUsed !== 'Sí') {
													setFieldValue('istestresult', 'N/A');
												} else {
													setFieldValue('istestresult', value);
												}
											}}
											onClose={() => {
												setFieldTouched('istestresult');
											}}
											value={values.istestresult || ''}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Positivo',
													text: 'Positivo',
													value: 'Positivo',
												},
												{
													key: 'Negativo',
													text: 'Negativo',
													value: 'Negativo',
												},
												{
													key: 'No se tuvo un resultado',
													text: 'No se tuvo un resultado',
													value: 'No se tuvo un resultado',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="10. ¿Se utilizó naloxona en este evento?"
											name="naloxone"
											selection
											required
											clearable
											onChange={(e, { value }) => {
												setFieldValue('naloxone', value);
											}}
											onClose={() => {
												setFieldTouched('naloxone');
											}}
											value={values.naloxone}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sí',
													text: 'Sí',
													value: 'Sí',
												},
												{
													key: 'No',
													text: 'No',
													value: 'No',
												},
											]}
											error={
												errors.naloxone && touched.naloxone && errors.naloxone
											}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="naloxone_if_no"
											label="Si es No, marcar la razón:"
											control={Dropdown}
											selectOnBlur={false}
											fluid
											search
											selection
											clearable
											disabled={!values.naloxone || values.naloxone !== 'No'}
											value={values.naloxone_if_no}
											onChange={(e, { value }) => {
												setFieldValue('naloxone_if_no', value);
											}}
											options={naloxoneValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Group grouped>
											<div
												hidden={values.naloxone === 'Sí' ? false : true}
												style={{ fontSize: '.92857143em' }}
											>
												<label style={{ fontWeight: 'bold' }}>
													11. Vía por la cual se administró la Naloxona
												</label>
												<div
													style={{ display: 'flex', alignItems: 'flex-end' }}
												>
													<input
														style={{ marginBottom: '2px' }}
														type="checkbox"
														checked={values.viaNaloxona?.includes('Intranasal')}
														value={'Intranasal'}
														onChange={(evt) => {
															let currArray = values.viaNaloxona;
															if (evt.target.checked) {
																if (
																	currArray?.includes('Intranasal') === false
																) {
																	currArray.push('Intranasal');
																}
																setFieldValue('viaNaloxona', currArray);
															} else {
																currArray = currArray?.filter(
																	(val) => val !== 'Intranasal'
																);
																setFieldValue('viaNaloxona', currArray);
															}
															//setCheckIntranasal(evt.target.checked);
														}}
													></input>
													<label>
														{' '}
														&nbsp;
														<strong style={{ color: 'black' }}>
															{' '}
															Intranasal{' '}
														</strong>{' '}
														¿Cuántas dosis de 4mg se le administraron?
													</label>
													<input
														style={{
															width: '60px',
															padding: '0px',
															borderLeft: 'black',
															borderRight: 'black',
															borderTop: 'black',
															borderRadius: '0px',
															paddingLeft: '12px',
														}}
														type="number"
														maxLength={5}
														inputMode="decimal"
														pattern="[.0-9]*"
														defaultValue={values.dosisIntranasal || ''}
														onInput={(evt) => {
															let result =
																evt.target.validity.patternMismatch === true
																	? values.dosisIntranasal
																	: evt.target.value;
															setFieldValue('dosisIntranasal', result);
														}}
													></input>{' '}
												</div>

												<div
													style={{ display: 'flex', alignItems: 'flex-end' }}
												>
													<input
														style={{ marginBottom: '2px' }}
														type="checkbox"
														checked={values.viaNaloxona?.includes(
															'Intramuscular'
														)}
														value={'Intramuscular'}
														onChange={(evt) => {
															let currArray = values.viaNaloxona;
															if (evt.target.checked) {
																if (
																	currArray?.includes('Intramuscular') === false
																) {
																	currArray.push('Intramuscular');
																}
																setFieldValue('viaNaloxona', currArray);
															} else {
																currArray = currArray?.filter(
																	(val) => val !== 'Intramuscular'
																);
																setFieldValue('viaNaloxona', currArray);
															}
															//setCheckIntramuscular(evt.target.checked);
														}}
													></input>
													<label>
														{' '}
														&nbsp;
														<strong style={{ color: 'black' }}>
															{' '}
															Intramuscular{' '}
														</strong>{' '}
														¿Cuántos mg se le administraron?
													</label>
													<input
														style={{
															width: '60px',
															padding: '0px',
															borderLeft: 'black',
															borderRight: 'black',
															borderTop: 'black',
															borderRadius: '0px',
															paddingLeft: '12px',
														}}
														type="text"
														//clearable
														maxLength={5}
														inputMode="number"
														pattern="[.0-9]*"
														defaultValue={values.dosisIntramuscular}
														onInput={(evt) => {
															let result =
																evt.target.validity.patternMismatch === true
																	? values.dosisIntramuscular
																	: evt.target.value;
															setFieldValue('dosisIntramuscular', result);
														}}
													></input>{' '}
													mg
												</div>

												<div
													style={{ display: 'flex', alignItems: 'flex-end' }}
												>
													<input
														style={{ marginBottom: '2px' }}
														type="checkbox"
														checked={values.viaNaloxona?.includes('Desconoce')}
														value={'Desconoce'}
														onChange={(evt) => {
															let currArray = values.viaNaloxona;
															if (evt.target.checked) {
																if (
																	currArray?.includes('Desconoce') === false
																) {
																	currArray.push('Desconoce');
																}
																setFieldValue('viaNaloxona', currArray);
															} else {
																currArray = currArray?.filter(
																	(val) => val !== 'Desconoce'
																);
																setFieldValue('viaNaloxona', currArray);
															}
															//setCheckDesconoce(evt.target.checked);
														}}
													></input>
													<label>
														{' '}
														&nbsp;
														<strong style={{ color: 'black' }}>
															{' '}
															Desconoce{' '}
														</strong>
													</label>
												</div>
											</div>
										</Form.Group>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="12. ¿Quién administró la naloxona?"
											name="administrator"
											clearable
											selection
											onChange={(e, { value }) => {
												setFieldValue('administrator', value);
											}}
											onClose={() => {
												setFieldTouched('administrator');
											}}
											value={values.administrator}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Amigo',
													text: 'Amigo',
													value: 'Amigo',
												},
												{
													key: 'Compañero/a de consumo',
													text: 'Compañero/a de consumo',
													value: 'Compañero/a de consumo',
												},
												{
													key: 'Emergencias médicas',
													text: 'Emergencias médicas',
													value: 'Emergencias médicas',
												},
												{
													key: 'Familiar',
													text: 'Familiar',
													value: 'Familiar',
												},
												{
													key: 'Oficial correccional',
													text: 'Oficial correccional',
													value: 'Oficial correccional',
												},
												{
													key: 'Persona desconocida (Civil)',
													text: 'Persona desconocida (Civil)',
													value: 'Persona desconocida (Civil)',
												},
												{
													key: 'Policía estatal',
													text: 'Policía estatal',
													value: 'Policía estatal',
												},
												{
													key: 'Policía municipal',
													text: 'Policía municipal',
													value: 'Policía municipal',
												},
												{
													key: 'Trabajador/a de alcance comunitario',
													text: 'Trabajador/a de alcance comunitario',
													value: 'Trabajador/a de alcance comunitario',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											required
											label="13. ¿Los opioides fueron recetados?"
											name="prescribed"
											value={values.prescribed}
											selection
											clearable
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sí',
													value: 'Sí',
													text: 'Sí',
												},
												{
													key: 'No',
													value: 'No',
													text: 'No',
												},
												{
													key: 'Desconoce',
													value: 'Desconoce',
													text: 'Desconoce',
												},
											]}
											onClose={() => {
												setFieldTouched('prescribed');
											}}
											onChange={(e, { value }) => {
												setFieldValue('prescribed', value);
											}}
											error={
												errors.prescribed &&
												touched.prescribed &&
												errors.prescribed
											}
										/>
									</Form.Group>
									<Form.Group widths="equal" grouped>
										<Form.Field
											label="14.  ¿Qué opioide(s) había consumido la persona afectada?  (marque todas las que aplique):"
											name="opioids"
											value={values.opioids || []}
											selection
											multiple
											clearable
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													text: 'Buprenorfina (Subutex, Suboxone)',
													value: 'Buprenorfina (Subutex, Suboxone)',
													key: 'Buprenorfina (Subutex, Suboxone)',
												},
												{ text: 'Codeína', value: 'Codeína', key: 'Codeína' },
												{
													text: 'Fentanilo',
													value: 'Fentanilo',
													key: 'Fentanilo',
												},
												{ text: 'Heroína', value: 'Heroína', key: 'Heroína' },
												{
													text: 'Hidrocodona (Vicodin)',
													value: 'Hidrocodona (Vicodin)',
													key: 'Hidrocodona (Vicodin)',
												},
												{
													text: 'Meperidina (Demerol)',
													value: 'Meperidina (Demerol)',
													key: 'Meperidina (Demerol)',
												},
												{
													text: 'Metadona',
													value: 'Metadona',
													key: 'Metadona',
												},
												{
													text: 'Morfina (MSContin)',
													value: 'Morfina (MSContin)',
													key: 'Morfina (MSContin)',
												},
												{
													text: 'Oxicodona (Oxycontin)',
													value: 'Oxicodona (Oxycontin)',
													key: 'Oxicodona (Oxycontin)',
												},
												{
													text: 'Percocet',
													value: 'Percocet',
													key: 'Percocet',
												},
												{
													text: 'Tramadol (Ultram) ',
													value: 'Tramadol (Ultram) ',
													key: 'Tramadol (Ultram) ',
												},
												{
													text: 'Speedball',
													value: 'Speedball',
													key: 'Speedball',
												},
												{
													text: 'Desconoce',
													value: 'Desconoce',
													key: 'Desconoce',
												},
												{ text: 'Otro', value: 'Otro', key: 'Otro' },
											]}
											onChange={(e, { value }) => {
												setFieldValue('opioids', value);
											}}
											required
											error={
												errors.opioids && touched.opioids && errors.opioids
											}
										/>
										<Form.Field
											name="opioidsOther"
											disabled={!_.includes(values.opioids, 'Otro')}
											label="Especifique otro opioide/fármaco"
											value={values.opioidsOther || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="other_substance"
											label="15. Otras sustancias consumidas (marque todas las que aplique):"
											control={Dropdown}
											selectOnBlur={false}
											multiple
											selection
											clearable
											value={values.other_substance || []}
											onChange={(e, { value }) => {
												setFieldValue('other_substance', value);
											}}
											options={other_substanceValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
											required
											error={errors.other_substance && touched.other_substance}
										/>
										<Form.Field
											name="other_substance_Especifique"
											label="Especifique"
											onChange={handleChange}
											disabled={!_.includes(values.other_substance, 'Otra')}
											onBlur={handleBlur}
											value={values.other_substance_Especifique || ''}
											control={Input}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="15b. Opioides adquiridos en:"
											name="opioidesLugar"
											selection
											clearable
											onChange={(e, { value }) => {
												setFieldValue('opioidesLugar', value);
											}}
											onClose={() => {
												setFieldTouched('opioidesLugar');
											}}
											value={values.opioidesLugar}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Calle',
													value: 'Calle',
													text: 'Calle',
												},
												{
													key: 'Farmacia',
													value: 'Farmacia',
													text: 'Farmacia',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											required
											error={errors.opioidesLugar && touched.opioidesLugar}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											label="16. Síntomas de sobredosis que presentó la persona afectada (marque todas las que aplique):"
											name="sintomasSobredosis"
											value={values.sintomasSobredosis || []}
											control={Dropdown}
											selectOnBlur={false}
											multiple
											selection
											clearable
											onChange={(e, { value }) => {
												setFieldValue('sintomasSobredosis', value);
											}}
											options={symptoms_overdoseValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
										/>
										<Form.Field
											name="other_symptoms_overdose"
											label="Especifique"
											onChange={handleChange}
											disabled={!_.includes(values.sintomasSobredosis, 'Otro')}
											onBlur={handleBlur}
											value={values.other_symptoms_overdose || ''}
											control={Input}
										/>
									</Form.Group>
								</div>
								<div className="border round mb-10">
									<div className="round-t fill-grey strong p-10 mb-20">
										Resultado del evento de la posible sobredosis
									</div>
									<Form.Group widths="equal">
										<Form.Field
											name="estadoPersona"
											label="17. La persona afectada por la sobredosis se encuentra (marque todas las que aplique):"
											control={Dropdown}
											selectOnBlur={false}
											multiple
											selection
											clearable
											value={values.estadoPersona || []}
											onChange={(e, { value }) => {
												setFieldValue('estadoPersona', value);
												setFieldValue('passed', value.includes('Murió') ? 'Sí' : 'No');
											}}
											options={overDoseValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
										/>
									</Form.Group>
									<Form.Group grouped widths="equal">
										<Form.Field
											name="where"
											selection
											clearable
											label="18. La persona afectada fue trasladada a:"
											control={Dropdown}
											selectOnBlur={false}
											onClose={() => {
												setFieldTouched('where');
											}}
											onChange={(e, { value }) => {
												setFieldValue('where', value);
											}}
											value={values.where || ''}
											options={[
												{
													key: 'Reusó apoyo adicional',
													text: 'Reusó apoyo adicional',
													value: 'Reusó apoyo adicional',
												},
												{
													key: 'Centro de tratamiento',
													text: 'Centro de tratamiento',
													value: 'Centro de tratamiento',
												},
												{
													key: 'Institución Correccional',
													text: 'Institución Correccional',
													value: 'Institución Correccional',
												},
												{
													key: 'Cuartel de la policía',
													text: 'Cuartel de la policía',
													value: 'Cuartel de la policía',
												},
												{
													key: 'Sala de Emergencia (Hospital: ______)',
													text: 'Sala de Emergencia (Hospital: ______)',
													value: 'Sala de Emergencia (Hospital: ______)',
												},
												{
													key: 'Emergencias Médicas Correccional',
													text: 'Emergencias Médicas Correccional',
													value: 'Emergencias Médicas Correccional',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											error={
												values.passed !== 'Sí' &&
												errors.where &&
												touched.where &&
												errors.where
											}
										/>
										<Form.Field
											label="Especifique"
											name="otherWhere"
											disabled={
												!_.isEqual(
													values.where,
													'Sala de Emergencia (Hospital: ______)'
												)
											}
											control={Input}
											value={values.otherWhere || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="description"
											label="19. Breve descripción del evento y/o comentarios adicionales:"
											control={TextArea}
											value={values.description || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
								</div>
								<div className="border round mb-10">
									<div className="round-t fill-grey strong p-10 mb-20">
										Información de la persona afectada
									</div>
									<Form.Group widths="equal">
										<Form.Field
											label="20. Reside en Puerto Rico"
											name="resident"
											selection
											clearable
											control={Dropdown}
											selectOnBlur={false}
											onClose={() => {
												setFieldTouched('resident');
											}}
											onChange={(e, { value }) => {
												setFieldValue('resident', value);
											}}
											value={values.resident}
											options={[
												{
													key: 'Sí',
													text: 'Sí',
													value: 'Sí',
												},
												{
													key: 'No',
													text: 'No',
													value: 'No',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
										/>
										<Form.Field
											name="country"
											label="Favor indique el país donde reside"
											control={Input}
											disabled={!_.includes(values.resident, 'No')}
											value={values.country || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<Form.Field
											name="state"
											label="Favor indique el estado donde reside"
											control={Input}
											disabled={!_.includes(values.resident, 'No')}
											value={values.state || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="home"
											label="21. Vivienda de la persona afectada"
											required
											control={Dropdown}
											selectOnBlur={false}
											selection
											clearable
											value={values.home}
											options={[
												{
													key: 'Albergue',
													text: 'Albergue',
													value: 'Albergue',
												},
												{
													key: 'Casa de familiar/amistad',
													text: 'Casa de familiar/amistad',
													value: 'Casa de familiar/amistad',
												},
												{
													key: 'Casa Propia',
													text: 'Casa Propia',
													value: 'Casa Propia',
												},
												{
													key: 'Casa rescatada (abandonada)',
													text: 'Casa rescatada (abandonada)',
													value: 'Casa rescatada (abandonada)',
												},
												{
													key: 'En las calles',
													text: 'En las calles',
													value: 'En las calles',
												},
												{
													key: 'Hogar transitorio',
													text: 'Hogar transitorio',
													value: 'Hogar transitorio',
												},
												{
													key: 'Institución carcelaria',
													text: 'Institución carcelaria',
													value: 'Institución carcelaria',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
											]}
											onChange={(e, { value }) => {
												setFieldValue('home', value);
											}}
											onClose={() => {
												setFieldTouched('home');
											}}
											error={errors.home && touched.home && errors.home}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="formal_treatment"
											label="22. Persona afectada se encuentra recibiendo tratamiento con: "
											control={Dropdown}
											selectOnBlur={false}
											fluid
											search
											selection
											clearable
											value={values.formal_treatment}
											onChange={(e, { value }) => {
												setFieldValue('formal_treatment', value);
											}}
											options={formal_treatmentValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
										/>
									</Form.Group>
									<Form.Group widths="equal" grouped>
										<Form.Field
											name="institucionesValor"
											label="23. Instituciones donde estuvo la persona afectada por la sobredosis en el último mes (marque todas las que aplique):"
											control={Dropdown}
											selectOnBlur={false}
											multiple
											selection
											clearable
											value={values.institucionesValor || []}
											options={[
												{
													key: 'Centro de tratamiento',
													text: 'Centro de tratamiento',
													value: 'Centro de tratamiento',
												},

												{
													key: 'Detención policiaca (24 horas o más)',
													text: 'Detención policiaca (24 horas o más)',
													value: 'Detención policiaca (24 horas o más)',
												},
												{
													key: 'Hospital de salud mental',
													text: 'Hospital de salud mental',
													value: 'Hospital de salud mental',
												},
												{
													key: 'Institución carcelaria',
													text: 'Institución carcelaria',
													value: 'Institución carcelaria',
												},
												{
													key: 'Sala de emergencia',
													text: 'Sala de emergencia',
													value: 'Sala de emergencia',
												},
												{
													key: 'Desconoce',
													text: 'Desconoce',
													value: 'Desconoce',
												},
												{
													key: 'Otro (especifique)',
													text: 'Otro (especifique)',
													value: 'Otro (especifique)',
												},
											]}
											onChange={(e, { value }) => {
												setFieldValue('institucionesValor', value);
											}}
										/>
										<Form.Field
											name="especifiqueInstituciones"
											label="Especifique"
											disabled={
												!_.includes(
													values.institucionesValor,
													'Otro (especifique)'
												)
											}
											control={Input}
											value={values.especifiqueInstituciones || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="estrategiaDeReduccion"
											label="24. Estrategia de reducción de daños que ha participado la persona afetada en el último mes (marque todas las que aplique):"
											control={Dropdown}
											selectOnBlur={false}
											multiple
											selection
											clearable
											value={values.estrategiaDeReduccion || []}
											onChange={(e, { value }) => {
												setFieldValue('estrategiaDeReduccion', value);
											}}
											options={harm_reductionValue.map((item) => {
												return {
													key: item,
													text: item,
													value: item,
												};
											})}
										/>
										<Form.Field
											className="display-grid"
											name="especifiqueEstrategia"
											label="Especifique"
											disabled={
												!_.includes(values.estrategiaDeReduccion, 'Otra')
											}
											control={Input}
											value={values.especifiqueEstrategia || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
								</div>
								<div className="border round mb-10">
									<div className="round-t fill-grey strong p-10 mb-20">
										Información de la persona que reporta el evento
									</div>
									<Form.Group widths={'equal'}>
										<Form.Field
											name="form_responsible"
											selection
											clearable
											label="25. Formulario respondido por:"
											onChange={(e, { value }) => {
												setFieldValue('form_responsible', value);
											}}
											value={values.form_responsible}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sobreviviente de la sobredosis',
													text: 'Sobreviviente de la sobredosis',
													value: 'Sobreviviente de la sobredosis',
												},
												{
													key: 'Persona que observó o atendió la sobredosis',
													text: 'Persona que observó o atendió la sobredosis',
													value: 'Persona que observó o atendió la sobredosis',
												},
											]}
										/>
									</Form.Group>
									<Form.Group>
										<Form.Field
											width={9}
											name="provider"
											required
											selection
											label="26. ¿Qué entidad le brindó la naloxona para el uso en la comunidad?"
											control={Dropdown}
											selectOnBlur={false}
											onClose={() => {
												setFieldTouched('provider');
											}}
											onChange={(e, { value }) => {
												setFieldValue('provider', value);
											}}
											value={values.provider}
											options={[
												{
													key: 'ASSMCA',
													text: 'ASSMCA',
													value: 'ASSMCA',
												},
												{
													key: 'Dept. de Salud',
													text: 'Dept. de Salud',
													value: 'Dept. de Salud',
												},
												{
													key: 'Otro (especifique)',
													text: 'Otro (especifique)',
													value: 'Otro (especifique)',
												},
											]}
											error={
												errors.provider && touched.provider && errors.provider
											}
										/>
										<Form.Field
											width={7}
											name="otherProvider"
											label="Especifique"
											value={values.otherProvider || ''}
											disabled={
												!_.includes(values.provider, 'Otro (especifique)')
											}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
										/>
									</Form.Group>
									<div className="labelSize" style={{ marginBottom: '6px' }}>
										27. Código de Identificación del Cuestionario (colocar
										información de la persona que está respondiendo el
										cuestionario):{' '}
									</div>
									<Form.Group widths="equal">
										<Form.Field
											label="Inicial nombre padre: "
											name="father_initial"
											//selection
											control={Input}
											onChange={(e, { value }) => {
												setFieldValue('father_initial', value);
											}}
											value={values.father_initial || ''}
										/>
										<Form.Field
											label="Inicial nombre madre: "
											name="mother_initial"
											//selection
											control={Input}
											onChange={(e, { value }) => {
												setFieldValue('mother_initial', value);
											}}
											value={values.mother_initial || ''}
										/>
										<Form.Field
											label="Día de su nacimiento: "
											name="father_dob"
											//selection
											type="number"
											control={Input}
											onChange={(e, { value }) => {
												setFieldValue('father_dob', value);
											}}
											value={values.father_dob || ''}
										/>
										<Form.Field
											label="Inicial del mes de su nacimiento: "
											name="month_of_birth"
											//selection
											type="text"
											control={Input}
											onChange={(e, { value }) => {
												setFieldValue('month_of_birth', value);
											}}
											value={values.month_of_birth || ''}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											required
											name="contactName"
											label="28. Nombre"
											value={values.contactName || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
											error={
												errors.contactName &&
												touched.contactName &&
												errors.contactName
											}
										/>
										<Form.Field
											required
											name="contactLastName"
											label="29. Apellidos"
											value={values.contactLastName || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
											error={
												errors.contactLastName &&
												touched.contactLastName &&
												errors.contactLastName
											}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											required
											name="phone"
											type="tel"
											label="30. Teléfono"
											value={values.phone || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
											error={errors.phone && touched.phone && errors.phone}
										/>
										<Form.Field
											required
											name="email"
											type="email"
											label="31. Correo electrónico"
											value={values.email || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											control={Input}
											error={errors.email && touched.email && errors.email}
										/>
									</Form.Group>
									<Form.Group widths="equal">
										<Form.Field
											name="typeOfEntity"
											selection
											required
											label="32. Tipo de Entidad"
											control={Dropdown}
											selectOnBlur={false}
											onClose={() => {
												setFieldTouched('typeOfEntity');
											}}
											onChange={(e, { value }) => {
												setFieldValue('typeOfEntity', value);
											}}
											value={values.typeOfEntity}
											options={[
												{
													key: 'Emergencias Médicas',
													text: 'Emergencias Médicas',
													value: 'Emergencias Médicas',
												},
												{
													key: 'Departamento de Corrección',
													text: 'Departamento de Corrección',
													value: 'Departamento de Corrección',
												},
												{
													key: 'Org. Comunitaria',
													text: 'Org. Comunitaria',
													value: 'Org. Comunitaria',
												},
												{
													key: 'Ninguno',
													text: 'Ninguno',
													value: 'Ninguno',
												},
												{
													key: 'Otro',
													text: 'Otro',
													value: 'Otro',
												},
											]}
											error={
												errors.typeOfEntity &&
												touched.typeOfEntity &&
												errors.typeOfEntity
											}
										/>
										<Form.Field
											name="entity"
											label="33. A que entidad, si alguna, usted pertenece:"
											value={values.entity}
											onChange={(e, { value }) => {
												setFieldValue('entity', value);
											}}
											onClose={() => {
												setFieldTouched('entity');
											}}
											control={Dropdown}
											selectOnBlur={false}
											selection
											search
											options={[
												{
													key: 'Adonai Medical Transport',
													text: 'Adonai Medical Transport',
													value: 'Adonai Medical Transport',
												},
												{
													key: 'Albergue Rodante Camino a tu Recuperación',
													text: 'Albergue Rodante Camino a tu Recuperación',
													value: 'Albergue Rodante Camino a tu Recuperación',
												},
												{
													key: 'Angeles de la Noche-Arecibo',
													text: 'Angeles de la Noche-Arecibo',
													value: 'Angeles de la Noche-Arecibo',
												},
												{
													key: 'APS Health',
													text: 'APS Health',
													value: 'APS Health',
												},
												{
													key: 'BR Ambulance',
													text: 'BR Ambulance',
													value: 'BR Ambulance',
												},
												{
													key: 'Castro Medical Responde',
													text: 'Castro Medical Responde',
													value: 'Castro Medical Responde',
												},
												{
													key: 'CEM',
													text: 'CEM',
													value: 'CEM',
												},
												{
													key: 'Centro Casa Alborada',
													text: 'Centro Casa Alborada',
													value: 'Centro Casa Alborada',
												},
												{
													key: 'Centro Deambulantes Cristo Pobre',
													text: 'Centro Deambulantes Cristo Pobre',
													value: 'Centro Deambulantes Cristo Pobre',
												},
												{
													key: 'Centro de Detención Correccional - Oeste',
													text: 'Centro de Detención Correccional - Oeste',
													value: 'Centro de Detención Correccional - Oeste',
												},
												{
													key: 'Centro de Detención Correccional - Rio Grande',
													text: 'Centro de Detención Correccional - Rio Grande',
													value: 'Centro de Detención Correccional - Rio Grande',
												},
												{
													key: 'Centro de Detención Correccional - Salinas',
													text: 'Centro de Detención Correccional - Salinas',
													value: 'Centro de Detención Correccional - Salinas',
												},
												{
													key: 'Clínica APS Bayamón',
													text: 'Clínica APS Bayamón',
													value: 'Clínica APS Bayamón',
												},
												{
													key: 'Coalición San Juan',
													text: 'Coalición San Juan',
													value: 'Coalición San Juan',
												},

												{
													key: 'Comunidad Altos de Cuba',
													text: 'Comunidad Altos de Cuba',
													value: 'Comunidad Altos de Cuba',
												},
												{
													key: 'Complejo Correccional de Rehabilitación para Mujeres',
													text: 'Complejo Correccional de Rehabilitación para Mujeres',
													value: 'Complejo Correccional de Rehabilitación para Mujeres',
												},
												{
													key: 'Contigo en la Calle',
													text: 'Contigo en la Calle',
													value: 'Contigo en la Calle',
												},
												{
													key: 'CTIAM Cayey',
													text: 'CTIAM Cayey',
													value: 'CTIAM Cayey',
												},
												{
													key: 'CTIAM Fajardo',
													text: 'CTIAM Fajardo',
													value: 'CTIAM Fajardo',
												},
												{
													key: 'De Vuelta a la Vida',
													text: 'De Vuelta a la Vida',
													value: 'De Vuelta a la Vida',
												},

												{
													key: 'Delta Ambulance',
													text: 'Delta Ambulance',
													value: 'Delta Ambulance',
												},
												{
													key: 'DIPHOM Bayamón',
													text: 'DIPHOM Bayamón',
													value: 'DIPHOM Bayamón',
												},
												{
													key: 'Dreamlife Ambulance',
													text: 'Dreamlife Ambulance',
													value: 'Dreamlife Ambulance',
												},
												{
													key: 'El Punto en la Montaña',
													text: 'El Punto en la Montaña',
													value: 'El Punto en la Montaña',
												},
												{
													key: 'Emergency Medical Inc.',
													text: 'Emergency Medical Inc.',
													value: 'Emergency Medical Inc.',
												},
												{
													key: 'Estancia Corazón',
													text: 'Estancia Corazón',
													value: 'Estancia Corazón',
												},
												{
													key: 'Evolution Ambulance',
													text: 'Evolution Ambulance',
													value: 'Evolution Ambulance',
												},
												{
													key: 'FR CARA',
													text: 'FR CARA',
													value: 'FR CARA',
												},
												{
													key: 'Frenchys Ambulance',
													text: 'Frenchys Ambulance',
													value: 'Frenchys Ambulance',
												},
												{
													key: 'Guarabí Proyecto ORP Caribe',
													text: 'Guarabí Proyecto ORP Caribe',
													value: 'Guarabí Proyecto ORP Caribe',
												},
												{
													key: 'Guarabí Yararí',
													text: 'Guarabí Yararí',
													value: 'Guarabí Yararí',
												},
												{
													key: 'Health PROMED',
													text: 'Health PROMED',
													value: 'Health PROMED',
												},
												{
													key: 'Hogar Amparo',
													text: 'Hogar Amparo',
													value: 'Hogar Amparo',
												},
												{
													key: 'Hogar Casa La Providencia',
													text: 'Hogar Casa La Providencia',
													value: 'Hogar Casa La Providencia',
												},
												{
													key: 'Hogar Divino Niño',
													text: 'Hogar Divino Niño',
													value: 'Hogar Divino Niño',
												},
												{
													key: 'Hogar Guarabí',
													text: 'Hogar Guarabí',
													value: 'Hogar Guarabí',
												},
												{
													key: 'Hogar Nueva Vida Gurabo',
													text: 'Hogar Nueva Vida Gurabo',
													value: 'Hogar Nueva Vida Gurabo',
												},
												{
													key: 'Hogar Padre Vernard',
													text: 'Hogar Padre Vernard',
													value: 'Hogar Padre Vernard',
												},
												{
													key: 'Iniciativa Comunitaria',
													text: 'Iniciativa Comunitaria',
													value: 'Iniciativa Comunitaria',
												},
												{
													key: 'Intercambios Puerto Rico',
													text: 'Intercambios Puerto Rico',
													value: 'Intercambios Puerto Rico',
												},
												{
													key: 'International Medical Transport',
													text: 'International Medical Transport',
													value: 'International Medical Transport',
												},
												{
													key: 'Inst. Correccional - Centro Ingresos Ponce 676',
													text: 'Inst. Correccional - Centro Ingresos Ponce 676',
													value: 'Inst. Correccional - Centro Ingresos Ponce 676',
												},
												{
													key: 'Inst. Correccional - Máxima Seguridad Bayamón 292',
													text: 'Inst. Correccional - Máxima Seguridad Bayamón 292',
													value: 'Inst. Correccional - Máxima Seguridad Bayamón 292',
												},
												{
													key: 'Inst. Correccional - Ponce',
													text: 'Inst. Correccional - Ponce',
													value: 'Inst. Correccional - Ponce',
												},
												{
													key: 'Inst. Correccional - Ponce Máxima',
													text: 'Inst. Correccional - Ponce Máxima',
													value: 'Inst. Correccional - Ponce Máxima',
												},
												{
													key: 'Inst. Correccional - Ponce Mínima',
													text: 'Inst. Correccional - Ponce Mínima',
													value: 'Inst. Correccional - Ponce Mínima',
												},
												{
													key: 'Inst. Correccional - Ponce 224',
													text: 'Inst. Correccional - Ponce 224',
													value: 'Inst. Correccional - Ponce 224',
												},
												{
													key: 'Inst. Correccional - Ponce 501',
													text: 'Inst. Correccional - Ponce 501',
													value: 'Inst. Correccional - Ponce 501',
												},
												{
													key: 'Inst. Correccional - Ponce 705',
													text: 'Inst. Correccional - Ponce 705',
													value: 'Inst. Correccional - Ponce 705',
												},
												{
													key: 'Inst. Correccional - Ponce 1000',
													text: 'Inst. Correccional - Ponce 1000',
													value: 'Inst. Correccional - Ponce 1000',
												},
												{
													key: 'Inst. Correccional - Guayama',
													text: 'Inst. Correccional - Guayama',
													value: 'Inst. Correccional - Guayama',
												},
												{
													key: 'Inst. Correccional - Guayama 1000',
													text: 'Inst. Correccional - Guayama 1000',
													value: 'Inst. Correccional - Guayama 1000',
												},
												{
													key: 'Inst. Correccional - Guayama 296',
													text: 'Inst. Correccional - Guayama 296',
													value: 'Inst. Correccional - Guayama 296',
												},
												{
													key: 'Inst. Correccional - Guayama 500',
													text: 'Inst. Correccional - Guayama 500',
													value: 'Inst. Correccional - Guayama 500',
												},
												{
													key: 'Inst. Correccional - Bayamón',
													text: 'Inst. Correccional - Bayamón',
													value: 'Inst. Correccional - Bayamón',
												},
												{
													key: 'Inst. Correccional - Bayamón 501',
													text: 'Inst. Correccional - Bayamón 501',
													value: 'Inst. Correccional - Bayamón 501',
												},
												{
													key: 'Inst. Correccional - Bayamón 705',
													text: 'Inst. Correccional - Bayamón 705',
													value: 'Inst. Correccional - Bayamón 705',
												},
												{
													key: 'Inst. Correccional - Bayamón 1072',
													text: 'Inst. Correccional - Bayamón 1072',
													value: 'Inst. Correccional - Bayamón 1072',
												},
												{
													key: 'Inst. Correccional - Guerrero 304',
													text: 'Inst. Correccional - Guerrero 304',
													value: 'Inst. Correccional - Guerrero 304',
												},
												{
													key: 'Inst. Correccional - Sabana Hoyos',
													text: 'Inst. Correccional - Sabana Hoyos',
													value: 'Inst. Correccional - Sabana Hoyos',
												},
												{
													key: 'Inst. Correccional - Sabana Hoyos 216',
													text: 'Inst. Correccional - Sabana Hoyos 216',
													value: 'Inst. Correccional - Sabana Hoyos 216',
												},
												{
													key: 'Inst. Correccional - Sabana Hoyos 384',
													text: 'Inst. Correccional - Sabana Hoyos 384',
													value: 'Inst. Correccional - Sabana Hoyos 384',
												},
												{
													key: 'Inst. Correccional - Sabana Hoyos 782',
													text: 'Inst. Correccional - Sabana Hoyos 782',
													value: 'Inst. Correccional - Sabana Hoyos 782',
												},
												{
													key: 'LGS Ambulance',
													text: 'LGS Ambulance',
													value: 'LGS Ambulance',
												},
												{
													key: 'Life Guardians Ambulance',
													text: 'Life Guardians Ambulance',
													value: 'Life Guardians Ambulance',
												},
												{
													key: 'Manatí Medical Transport',
													text: 'Manatí Medical Transport',
													value: 'Manatí Medical Transport',
												},
												{
													key: 'Medic Citas',
													text: 'Medic Citas',
													value: 'Medic Citas',
												},
												{
													key: 'Medina Medical Transport',
													text: 'Medina Medical Transport',
													value: 'Medina Medical Transport',
												},
												{
													key: 'Mercado Ambulance',
													text: 'Mercado Ambulance',
													value: 'Mercado Ambulance',
												},
												{
													key: 'Migrant Health Center',
													text: 'Migrant Health Center',
													value: 'Migrant Health Center',
												},
												{
													key: 'Multiservice',
													text: 'Multiservice',
													value: 'Multiservice',
												},
												{
													key: 'Municipio Cidra',
													text: 'Municipio Cidra',
													value: 'Municipio Cidra',
												},
												{
													key: 'OMME Aguada',
													text: 'OMME Aguada',
													value: 'OMME Aguada',
												},
												{
													key: 'OMME Arecibo',
													text: 'OMME Arecibo',
													value: 'OMME Arecibo',
												},
												{
													key: 'OMME Barceloneta',
													text: 'OMME Barceloneta',
													value: 'OMME Barceloneta',
												},
												{
													key: 'OMME Caguas',
													text: 'OMME Caguas',
													value: 'OMME Caguas',
												},
												{
													key: 'OMME Camuy',
													text: 'OMME Camuy',
													value: 'OMME Camuy',
												},
												{
													key: 'OMME Carolina',
													text: 'OMME Carolina',
													value: 'OMME Carolina',
												},
												{
													key: 'OMME Cataño',
													text: 'OMME Cataño',
													value: 'OMME Cataño',
												},
												{
													key: 'OMME Cayey',
													text: 'OMME Cayey',
													value: 'OMME Cayey',
												},
												{
													key: 'OMME Cidra',
													text: 'OMME Cidra',
													value: 'OMME Cidra',
												},
												{
													key: 'OMME Coamo',
													text: 'OMME Coamo',
													value: 'OMME Coamo',
												},
												{
													key: 'OMME Corozal',
													text: 'OMME Corozal',
													value: 'OMME Corozal',
												},
												{
													key: 'OMME Fajardo',
													text: 'OMME Fajardo',
													value: 'OMME Fajardo',
												},
												{
													key: 'OMME Florida',
													text: 'OMME Florida',
													value: 'OMME Florida',
												},
												{
													key: 'OMME Guánica',
													text: 'OMME Guánica',
													value: 'OMME Guánica',
												},
												{
													key: 'OMME Guaynabo',
													text: 'OMME Guaynabo',
													value: 'OMME Guaynabo',
												},
												{
													key: 'OMME Humacao',
													text: 'OMME Humacao',
													value: 'OMME Humacao',
												},
												{
													key: 'OMME Isabela',
													text: 'OMME Isabela',
													value: 'OMME Isabela',
												},

												{
													key: 'OMME Juncos',
													text: 'OMME Juncos',
													value: 'OMME Juncos',
												},
												{
													key: 'OMME Las Piedras',
													text: 'OMME Las Piedras',
													value: 'OMME Las Piedras',
												},
												{
													key: 'OMME Loíza',
													text: 'OMME Loíza',
													value: 'OMME Loíza',
												},
												{
													key: 'OMME Luquillo',
													text: 'OMME Luquillo',
													value: 'OMME Luquillo',
												},
												{
													key: 'OMME Manatí',
													text: 'OMME Manatí',
													value: 'OMME Manatí',
												},
												{
													key: 'OMME Maunabo',
													text: 'OMME Maunabo',
													value: 'OMME Maunabo',
												},
												{
													key: 'OMME Morovis',
													text: 'OMME Morovis',
													value: 'OMME Morovis',
												},
												{
													key: 'OMME Orocovis',
													text: 'OMME Orocovis',
													value: 'OMME Orocovis',
												},
												{
													key: 'OMME San Juan',
													text: 'OMME San Juan',
													value: 'OMME San Juan',
												},
												{
													key: 'OMME Santa Isabel',
													text: 'OMME Santa Isabel',
													value: 'OMME Santa Isabel',
												},
												{
													key: 'OMME Toa Baja',
													text: 'OMME Toa Baja',
													value: 'OMME Toa Baja',
												},
												{
													key: 'OMME Utuado',
													text: 'OMME Utuado',
													value: 'OMME Utuado',
												},
												{
													key: 'OMME Vega Alta',
													text: 'OMME Vega Alta',
													value: 'OMME Vega Alta',
												},
												{
													key: 'OMME Vega Baja',
													text: 'OMME Vega Baja',
													value: 'OMME Vega Baja',
												},
												{
													key: 'OMME Yabucoa',
													text: 'OMME Yabucoa',
													value: 'OMME Yabucoa',
												},
												{
													key: 'PAR Apoyo Mutuo',
													text: 'PAR Apoyo Mutuo',
													value: 'PAR Apoyo Mutuo',
												},

												{
													key: 'Pereira Medical service',
													text: 'Pereira Medical service',
													value: 'Pereira Medical service',
												},
												{
													key: 'Plainfield Ambulance',
													text: 'Plainfield Ambulance',
													value: 'Plainfield Ambulance',
												},
												{
													key: 'Plaza Corazón',
													text: 'Plaza Corazón',
													value: 'Plaza Corazón',
												},
												{
													key: 'Policía Estatal Aguadilla',
													text: 'Policía Estatal Aguadilla',
													value: 'Policía Estatal Aguadilla',
												},
												{
													key: 'Policia Municipal Las Piedras',
													text: 'Policia Municipal Las Piedras',
													value: 'Policia Municipal Las Piedras',
												},
												{
													key: 'Policía Municipal Bayamón',
													text: 'Policía Municipal Bayamón',
													value: 'Policía Municipal Bayamón',
												},
												{
													key: 'Policía Municipal Caguas',
													text: 'Policía Municipal Caguas',
													value: 'Policía Municipal Caguas',
												},
												{
													key: 'Policía Municipal Isabela',
													text: 'Policía Municipal Isabela',
													value: 'Policía Municipal Isabela',
												},
												{
													key: 'Policía Municipal Las Piedras',
													text: 'Policía Municipal Las Piedras',
													value: 'Policía Municipal Las Piedras',
												},
												{
													key: 'Posa San Felipe',
													text: 'Posa San Felipe',
													value: 'Posa San Felipe',
												},
												{
													key: 'Priority Emergency Ambulance',
													text: 'Priority Emergency Ambulance',
													value: 'Priority Emergency Ambulance',
												},
												{
													key: 'Pro Health Ambulance',
													text: 'Pro Health Ambulance',
													value: 'Pro Health Ambulance',
												},
												{
													key: 'Programa Nuevo Amanecer',
													text: 'Programa Nuevo Amanecer',
													value: 'Programa Nuevo Amanecer',
												},
												{
													key: 'Proyecto Nuevo Horizonte',
													text: 'Proyecto Nuevo Horizonte',
													value: 'Proyecto Nuevo Horizonte',
												},
												{
													key: 'Proyecto PDO',
													text: 'Proyecto PDO',
													value: 'Proyecto PDO',
												},
												{
													key: 'Quality Critical Care',
													text: 'Quality Critical Care',
													value: 'Quality Critical Care',
												},
												{
													key: 'Salinas Emergency First Response Inc.',
													text: 'Salinas Emergency First Response Inc.',
													value: 'Salinas Emergency First Response Inc.',
												},
												{
													key: 'South Medical Response',
													text: 'South Medical Response',
													value: 'South Medical Response',
												},
												{
													key: 'Teen Challenge Bayamón',
													text: 'Teen Challenge Bayamón',
													value: 'Teen Challenge Bayamón',
												},
												{
													key: 'Toque de Angel',
													text: 'Toque de Angel',
													value: 'Toque de Angel',
												},
												{
													key: 'United Emergency',
													text: 'United Emergency',
													value: 'United Emergency',
												},
												{
													key: 'United Emergency Mayaguez',
													text: 'United Emergency Mayaguez',
													value: 'United Emergency Mayaguez',
												},
												{
													key: 'United EMS',
													text: 'United EMS',
													value: 'United EMS',
												},
												{
													key: 'Otro (especifique)',
													text: 'Otro (especifique)',
													value: 'Otro (especifique)',
												},
											]}
										/>
										<Form.Field
											name="entidad_otro"
											label="Otra Entidad"
											disabled={
												!_.includes(values.entity, 'Otro (especifique)')
											}
											control={Input}
											value={values.entidad_otro || ''}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									</Form.Group>
									<Form.Group>
										<Form.Field
											label="34. Necesita Naloxona:"
											name="need_naloxone"
											selection
											clearable
											onChange={(e, { value }) => {
												setFieldValue('need_naloxone', value);
											}}
											value={values.need_naloxone}
											control={Dropdown}
											selectOnBlur={false}
											options={[
												{
													key: 'Sí',
													text: 'Sí',
													value: 'Sí',
												},
												{
													key: 'No',
													text: 'No',
													value: 'No',
												},
											]}
										/>
									</Form.Group>

									{props.event.estado_duplicado && (
										<Form.Group widths="equal">
											<Form.Field
												name="duplicateState"
												selection
												required
												label="¿Duplicado?"
												control={Dropdown}
											selectOnBlur={false}
												onClose={() => {
													setFieldTouched('estado_duplicado');
												}}
												onChange={(e, { value }) => {
													setFieldValue('estado_duplicado', value);
												}}
												value={values.estado_duplicado}
												options={[
													{
														key: 'No Duplicado',
														text: 'No Duplicado',
														value: 'No Duplicado',
													},
													{
														key: 'Duplicado',
														text: 'Duplicado',
														value: 'Duplicado',
													},
													{
														key: 'Sin Evaluar',
														text: 'Sin Evaluar',
														value: 'Sin Evaluar',
													},
												]}
												error={
													errors.duplicateState &&
													touched.duplicateState &&
													errors.duplicateState
												}
											/>
										</Form.Group>
									)}
								</div>
							</Modal.Content>
							<Modal.Actions>
								<Button content="Cancelar" onClick={props.onClose} />
								<Button
									loading={isSubmitting}
									disabled={isSubmitting}
									type="submit"
									color="orange"
									content="Enviar"
								/>
							</Modal.Actions>
						</Modal>
					);
				}}
			</Formik>
		);

	return null;
}

export default EventEditor;
